// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---gatsby-theme-cara-src-templates-cara-tsx": () => import("./../../../../gatsby-theme-cara/src/templates/cara.tsx" /* webpackChunkName: "component---gatsby-theme-cara-src-templates-cara-tsx" */),
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("./../../../node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */)
}

